import React, { useEffect } from "react";

const Travel = () => {
    useEffect(() => {
        window.location.href = "https://www.youtube-nocookie.com/embed/ReXHwSS0r5U?playlist=ReXHwSS0r5U&autoplay=1&iv_load_policy=3&loop=1&start=";
    }, []);

    return null;
};

export default Travel;